import { render, staticRenderFns } from "./filesystems.vue?vue&type=template&id=53b90c4a&scoped=true&"
import script from "./filesystems.vue?vue&type=script&lang=js&"
export * from "./filesystems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b90c4a",
  null
  
)

export default component.exports